export { GOOGLE_MAP_MARKER } from './marker';

export { default as GOOGLE_MAP_STYLES } from './styles';

export const GOOGLE_MAPS_URL = 'https://maps.googleapis.com/maps/api/js';

export const GOOGLE_MAPS_CALLBACK = 'ACE_GOOGLE_MAPS_CALLBACK';

export const GOOGLE_MAP_DEFAULT_ZOOM = 12;
